import { TRANSFER_LAST_DOCUMENT_SAVE } from "./mutation-types";

export default {
  [TRANSFER_LAST_DOCUMENT_SAVE](state, lastDocument) {
    state.lastDocumentTransfer = lastDocument;
  }
};
